export default "__VITE_ASSET__Bbimdfub__"